(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9450],{

/***/ 9450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content013": function() { return /* binding */ Content013; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content013_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85363);
/* harmony import */ var _Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content013 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var pageLink = (ref1 = payload === null || payload === void 0 ? void 0 : payload.pageLink) !== null && ref1 !== void 0 ? ref1 : "";
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().inner),
            children: pageLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .PageLink */ .H_, {
                link: pageLink,
                className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                            className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
                            name: "arrow_slider_prev"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                        className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        color: "dark",
                        uppercase: true,
                        children: title
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Action */ .aU, {
                onClick: function() {
                    return router.back();
                },
                className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                            className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
                            name: "arrow_slider_prev"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                        className: (_Content013_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        color: "dark",
                        uppercase: true,
                        children: title
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content013);


/***/ }),

/***/ 85363:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content013_wrapper__aYwtb","title":"Content013_title__XK9Tz","icon":"Content013_icon__vo2__","arrow":"Content013_arrow__hSvwa","link":"Content013_link__UcaID"};

/***/ })

}]);